module.exports = __webpack_public_path__ + "brand-icons.a046592bac8f2fd96e99.woff";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/brand-icons.woff
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/brand-icons.woff
// module chunks = styles